<template>
  <main-content-layout title="론앤비즈" img-src="loan_and_biz_icon.png">
    <template v-slot:content>
      <div class="loan-and-biz-image-wrapper">
        <v-img
            class="loan-and-biz-image"
            :src="require(`@/assets/images/loan_and_biz.png`)"
            contain
            @click="routerLoanAndBiz"
        />
      </div>
    </template>
  </main-content-layout>
</template>

<script>
import {mapGetters} from "vuex";
import MainContentLayout from "@/pages/Main/components/layout/MainContentLayout.vue";

export default {
  name: "LoanAndBizRouting",
  components: {MainContentLayout},
  computed: {
    ...mapGetters("login", {memberRole: "memberRole"})
  },
  methods: {
    routerLoanAndBiz() {
      this.showAlert({message: "추후 업데이트 예정입니다!"});
      // const loanAndBizUrl = "";
      // window.open(loanAndBizUrl, "_blank");
    }
  }
}
</script>

<style lang="scss" scoped>
.loan-and-biz-image-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  .loan-and-biz-image {
    max-width: 100%;
    max-height: 100%;
    border-radius: 20px;
  }
  .loan-and-biz-image:hover {
    cursor: pointer;
  }
}
</style>